export default "__VITE_ASSET__CpkLI0Rp__"